import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-violet px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg1tq2s8nvn">
        <h2 className="text-center font-heading text-[1.15rem] font-extrabold uppercase text-white sm:text-[1.75rem]" data-id="element-20" data-mp="avcx0k0h7i8f">
          🎁 5 professional bonuses included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-21" data-mp="frtl5e7odwli">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border border-white/15 bg-white px-2.5 py-2 shadow-sm" data-id="element-22" data-mp="1t3nnxgy1uwm">
              <h3 className="font-body text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-navy sm:text-[0.88rem]" data-id="element-23" data-mp="3o2epa1jm0r5t">
                🎁 Bonus {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 font-body text-[0.68rem] font-semibold text-violet sm:text-[0.8rem]" data-id="element-24" data-mp="1mba0dd92a4p6">
                {bonus.subtitle}
              </p>
              <p className="mt-1 text-[0.78rem] leading-[1.35] text-graphite sm:text-[0.92rem]" data-id="element-25" data-mp="3ieg8b62g2b1w">
                {bonus.body}
              </p>
              <p className="mt-1 font-body text-[0.66rem] font-bold uppercase tracking-wide text-teal sm:text-[0.78rem]" data-id="element-26" data-mp="3deaepkcm6eh6">
                {bonus.steps}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}